import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useAssetState = () => React.useContext(Context)
export const useAsset = () => useAssetState()?.asset

const QUERY = gql`
  query Asset($id: ID) {
    asset(id: $id, filter: { includeDeleted: true }) {
      id
      name
      enabled
      place {
        id
        name
        resume
      }
      deleted
      insertedAt
      updatedAt
    }
  }
`

const AssetLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetLoader
